import { TitleAddChildrenMutation, TitleAddChildrenMutationContext } from '@warehouse/title/core';
import { useContext } from 'react';
import { useAddChildrenMutationImpl } from '@warehouse/title/infra';

export const useAddChildrenMutation: TitleAddChildrenMutation = (args) => {
	const impl = useContext(TitleAddChildrenMutationContext);
	const implResult = useAddChildrenMutationImpl(args);

	return impl ? impl(args) : implResult;
};
